import axios from 'axios';
import { Toast } from 'antd-mobile';
import config from './config';
import { getStore } from './storage';

const instance = axios.create({
  baseURL: config.backendBaseUrl,
  timeout: 30000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(
  (axiosConfig) => {
    const token = getStore('token');
    if (token) {
      axiosConfig.headers['X-User-Token'] = token;
    }
    return axiosConfig;
  },
  error => Promise.reject(error)
)

instance.interceptors.response.use(
  (response) => {
    const params = new URLSearchParams(window.location.search);
    const mobile = params.get('mobile');
    if (response.data.code === -1) {
      Toast.fail(response.data.msg, 2);
      if(mobile) {
        window.location.replace(`/login?mobile=${mobile}`);
      } else {
        window.location.replace('/login');
      }
    }
    return response.data;
  },
  (error) => {
    let errorMsg = null;
    if (error.response) {
      errorMsg = `网络异常[${error.response.status}]`;
    } else if (error.request) {
      if (error.request.readyState === 4 && error.request.status === 0) {
        errorMsg = '请求超时';
      } else {
        errorMsg = '请求失败';
      }
      Toast.fail(errorMsg, 2);
    }
    return Promise.reject(error);
  }
)

export default instance;